/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../../../core/tivo/tivo-redux-wrapper';
import { SET_HELP_PC_OPTIONS_LIST, SET_HELP_PC_SELECTED_OPTION } from '../help.types';
import { IPcHelpSelectedOption } from './IPcHelpSelectedOption';

export const setPcHelpListAction = (
    optionsList: Array<IPcHelpSelectedOption>,
): TivoPayloadAction<{
    optionsList: Array<IPcHelpSelectedOption>;
}> => ({
    type: SET_HELP_PC_OPTIONS_LIST,
    payload: { optionsList },
});

export const setSelectedPcHelpOptionAction = (
    selectedOption?: IPcHelpSelectedOption,
): TivoPayloadAction<{ selectedOption?: IPcHelpSelectedOption }> => ({
    type: SET_HELP_PC_SELECTED_OPTION,
    payload: { selectedOption },
});
